import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 8,
	viewBox: "0 0 16 8",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 7.17187L16 7.17188L9.41421 0.586088C8.63317 -0.194961 7.36684 -0.194961 6.58579 0.586088L0 7.17187Z" })
});
export default SvgIcoTriangle;
